module.exports = __webpack_public_path__ + "static/media/Nidorino_gaussian2.97cbd4d9.png";